// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"172":"fbab5d1a","468":"43c13072","489":"c776dd22"}[chunkId] + ".chunk.css";
};